import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogArticle = lazy(() => import('../pages/blog/article/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const TermsConditions = lazy(() => import('../pages/terms-conditions/page'));
const CookiePolicy = lazy(() => import('../pages/cookie-policy/page'));
const SemanticArchitecture = lazy(() => import('../pages/services/semantic-architecture/page'));
const SchemaMarkup = lazy(() => import('../pages/services/schema-markup/page'));
const ExtremeOptimization = lazy(() => import('../pages/services/extreme-optimization/page'));
const ProgressiveWebApp = lazy(() => import('../pages/services/progressive-web-app/page'));
const VoiceSearchSEO = lazy(() => import('../pages/services/voice-search-seo/page'));
const AIAgentsSEO = lazy(() => import('../pages/services/ai-agents-seo/page'));
const ComoLoHacemos = lazy(() => import('../pages/como-lo-hacemos/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticle />,
  },
  {
    path: '/como-lo-hacemos',
    element: <ComoLoHacemos />,
  },
  {
    path: '/servicios/arquitectura-semantica',
    element: <SemanticArchitecture />,
  },
  {
    path: '/servicios/schema-markup-avanzado',
    element: <SchemaMarkup />,
  },
  {
    path: '/servicios/optimizacion-extrema',
    element: <ExtremeOptimization />,
  },
  {
    path: '/servicios/progressive-web-app',
    element: <ProgressiveWebApp />,
  },
  {
    path: '/servicios/voice-search-seo',
    element: <VoiceSearchSEO />,
  },
  {
    path: '/servicios/seo-agentes-ia',
    element: <AIAgentsSEO />,
  },
  {
    path: '/politica-privacidad',
    element: <PrivacyPolicy />,
  },
  {
    path: '/terminos-condiciones',
    element: <TermsConditions />,
  },
  {
    path: '/politica-cookies',
    element: <CookiePolicy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
